import React, {
  createContext,
  useReducer,
  Dispatch,
  PropsWithChildren
} from 'react';
import {
  breadcrumbReducer,
  activeChannelsReducer,
  BreadcrumbActions,
  ActiveChannelsActions
} from './reducers';
import { Notification } from '../interfaces/api/Notifications';
export type StateType = {
  breadcrumbNotificationName: string;
  activeChannels: Notification['channels'];
};

const initialState: StateType = {
  breadcrumbNotificationName: '',
  activeChannels: []
};

export type DispatchType = Dispatch<BreadcrumbActions | ActiveChannelsActions>;

const AppContext = createContext<{
  state: StateType;
  dispatch: DispatchType;
}>({
  state: initialState,
  dispatch: () => null
});

const mainReducer = (
  state: StateType,
  action: BreadcrumbActions | ActiveChannelsActions
): StateType => ({
  breadcrumbNotificationName: breadcrumbReducer(
    state,
    action as BreadcrumbActions
  ).breadcrumbNotificationName,
  activeChannels: activeChannelsReducer(state, action as ActiveChannelsActions)
    .activeChannels
});

const AppProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(mainReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppProvider, AppContext };
